<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 400 265" enable-background="new 0 0 400 265" xml:space="preserve">
<path fill="#E0E6E8" opacity="1.000000" stroke="none" 
	d="
M1.000000,249.000000 
	C1.000000,172.312439 1.000000,95.624878 1.298538,18.782202 
	C2.739237,17.441048 3.774555,16.123529 5.042942,15.092823 
	C9.413536,11.541220 11.971347,5.853875 18.102503,4.291217 
	C19.271978,3.993151 20.044394,2.137191 21.000000,1.000000 
	C139.020889,1.000000 257.041779,1.000000 375.198914,1.313509 
	C375.861023,2.397612 376.414703,3.851688 376.908325,3.831565 
	C381.175751,3.657596 383.586609,6.655251 386.323120,9.060859 
	C392.964600,14.899257 398.565369,22.279394 398.719788,30.839695 
	C399.344482,65.460953 398.889435,100.101685 398.487000,134.787598 
	C397.149750,136.241287 396.158356,137.642624 395.016327,139.362335 
	C393.651093,141.411774 392.434875,143.141647 391.222198,144.874039 
	C373.766541,169.810974 350.088715,187.604248 323.652161,201.589874 
	C304.609589,211.663879 284.832550,220.513062 264.855103,228.604919 
	C248.686356,235.154053 231.798355,239.979431 215.098572,245.146667 
	C204.685410,248.368683 194.060776,250.932526 183.473206,253.558563 
	C172.573608,256.261963 161.604599,258.685913 150.664337,261.225037 
	C143.777771,262.823364 136.888214,264.408783 130.000000,266.000000 
	C93.979103,266.000000 57.958210,266.000000 21.798923,265.690491 
	C20.074575,264.265533 18.527510,263.088531 16.889854,262.055023 
	C15.670013,261.285187 14.039200,260.977722 13.102452,259.983093 
	C10.137333,256.834656 7.506862,253.370285 4.528960,250.235199 
	C3.765434,249.431366 2.198074,249.391068 1.000000,249.000000 
M226.991791,113.537369 
	C217.490707,105.654686 206.684402,104.852745 195.871048,109.362076 
	C181.815353,115.223495 175.404205,131.334686 182.580811,145.455383 
	C187.835068,155.793640 204.012802,163.878067 218.852249,158.133865 
	C228.726318,154.311691 234.677628,147.538284 236.370026,137.369400 
	C237.912003,128.104248 234.863174,120.125114 226.991791,113.537369 
M52.977165,158.462555 
	C62.682220,156.414139 70.546669,147.535645 72.282448,136.667999 
	C74.006760,125.872177 69.419792,116.402946 60.392937,111.009003 
	C50.719975,105.228981 40.156017,107.200150 29.841093,107.086044 
	C29.074377,107.077568 27.615435,109.383247 27.602871,110.624496 
	C27.447849,125.939339 27.446793,141.256897 27.611017,156.571564 
	C27.623730,157.757034 29.189156,159.952286 30.011923,159.942352 
	C37.459076,159.852341 44.901550,159.375320 52.977165,158.462555 
M352.782257,154.890533 
	C356.394440,160.501373 362.104492,161.955978 368.718292,158.886032 
	C363.506042,152.084091 358.305878,145.297867 353.037750,138.423004 
	C353.898071,137.806625 354.261078,137.468735 354.687683,137.262405 
	C355.130920,137.048019 355.671295,137.030548 356.108215,136.807541 
	C362.104919,133.746796 365.306946,128.875549 364.909119,122.108505 
	C364.533173,115.714241 361.942444,110.137840 355.183868,108.881294 
	C347.044830,107.368080 338.694092,106.993423 330.179413,106.099030 
	C330.179413,124.922653 330.179413,142.307846 330.179413,159.800659 
	C333.579987,159.800659 336.660797,159.800659 340.544037,159.800659 
	C340.544037,153.025421 340.544037,146.551025 340.544037,140.076630 
	C340.906097,140.016663 341.268158,139.956711 341.630219,139.896759 
	C345.194244,144.705078 348.758301,149.513397 352.782257,154.890533 
M311.504761,136.966354 
	C313.667664,136.966309 315.843140,136.818436 317.990509,137.000931 
	C321.192688,137.273071 322.401031,136.106247 322.414825,132.773087 
	C322.429016,129.337372 321.331909,127.927345 317.825806,128.072571 
	C313.254242,128.261932 308.668884,128.118912 304.018951,128.118912 
	C304.018951,123.600029 304.018951,119.892548 304.018951,115.704338 
	C310.513062,115.704338 316.598877,115.704338 322.714844,115.704338 
	C322.714844,112.500481 322.714844,109.800713 322.714844,107.213432 
	C312.600189,107.213432 302.852692,107.213432 292.991394,107.213432 
	C292.991394,124.933487 292.991394,142.292358 292.991394,159.896790 
	C303.110718,159.896790 312.870758,159.896790 322.743286,159.896790 
	C322.743286,157.045212 322.743286,154.317749 322.743286,151.094345 
	C316.342468,151.094345 310.261230,151.094345 303.901367,151.094345 
	C303.901367,146.203796 303.901367,141.818497 303.901367,136.966354 
	C306.275757,136.966354 308.401947,136.966354 311.504761,136.966354 
M127.747803,153.192795 
	C134.673691,143.623581 131.239426,133.412537 121.059441,129.473389 
	C117.569321,128.122894 114.072144,126.654076 110.876518,124.740990 
	C109.439941,123.880966 107.784508,121.673035 107.963486,120.303482 
	C108.147324,118.896690 110.358025,116.853584 111.840584,116.708130 
	C114.791534,116.418610 117.880363,117.091835 120.851669,117.675598 
	C122.000664,117.901329 122.985268,118.963821 124.132080,119.701241 
	C125.930054,117.320099 127.453514,115.302498 128.992081,113.264893 
	C123.693405,107.667938 117.469070,106.480797 110.628853,107.015892 
	C103.158325,107.600304 97.777779,112.620155 96.530609,120.305748 
	C95.459663,126.905350 98.862289,132.007645 106.176018,134.944748 
	C109.662315,136.344803 113.314720,137.540894 116.444252,139.532715 
	C118.050491,140.555008 119.742805,143.305527 119.463158,144.945374 
	C119.130226,146.897675 117.062218,149.274994 115.153008,150.106186 
	C108.699432,152.915863 103.877174,149.540756 99.548904,144.449661 
	C97.356888,146.636169 95.380234,148.607849 93.533051,150.450394 
	C100.828560,162.839111 120.628906,162.725540 127.747803,153.192795 
M273.794708,139.293396 
	C278.396271,128.731400 282.997864,118.169395 287.635345,107.525002 
	C279.050110,105.905022 276.289185,106.584183 274.479126,110.770447 
	C272.531525,115.274803 270.780640,119.864838 268.803223,124.355522 
	C266.467804,129.659103 263.981689,134.896301 261.210541,140.924469 
	C258.750549,135.377518 256.771637,130.934601 254.809052,126.484474 
	C252.827530,121.991280 250.853439,117.494759 248.891815,112.992851 
	C245.990875,106.335297 242.890381,105.141685 235.256653,108.004723 
	C236.501801,110.821945 237.738647,113.630615 238.983688,116.435646 
	C245.080399,130.171219 251.113937,143.935867 257.389832,157.589111 
	C257.948853,158.805237 260.115143,159.980072 261.485291,159.925583 
	C262.799866,159.873306 264.578705,158.468216 265.237030,157.186783 
	C268.137299,151.541550 270.706238,145.726105 273.794708,139.293396 
M149.872742,109.260246 
	C147.875793,110.711555 145.792358,112.058525 143.895615,113.630745 
	C129.325531,125.708069 130.909943,146.449402 147.186890,156.019775 
	C156.372299,161.420532 165.933212,161.337082 175.516144,157.534409 
	C175.516144,153.892029 175.516144,150.393784 175.516144,146.671677 
	C164.880905,152.801727 155.970352,152.455734 149.678726,145.943756 
	C144.112747,140.182816 143.160355,131.389984 147.168182,124.556931 
	C150.159302,119.457275 154.686447,116.204628 160.327332,116.276611 
	C165.483582,116.342392 170.616806,118.213997 175.794708,119.297028 
	C175.794708,116.423447 175.794708,112.957642 175.794708,109.771538 
	C167.361191,105.174217 159.026398,104.641586 149.872742,109.260246 
M81.713531,106.829147 
	C78.015854,106.263535 76.774239,107.782036 76.827606,111.544556 
	C77.016640,124.874832 76.901299,138.209427 76.901283,151.542374 
	C76.901276,161.183044 76.901749,161.186569 86.760689,159.843475 
	C87.042946,159.805023 87.289246,159.502716 87.664238,159.247177 
	C87.664238,142.028473 87.664238,124.743286 87.664238,107.120781 
	C85.814064,107.015572 84.176064,106.922424 81.713531,106.829147 
z"/>
<path fill="#FF6E02" opacity="1.000000" stroke="none" 
	d="
M130.468658,266.000000 
	C136.888214,264.408783 143.777771,262.823364 150.664337,261.225037 
	C161.604599,258.685913 172.573608,256.261963 183.473206,253.558563 
	C194.060776,250.932526 204.685410,248.368683 215.098572,245.146667 
	C231.798355,239.979431 248.686356,235.154053 264.855103,228.604919 
	C284.832550,220.513062 304.609589,211.663879 323.652161,201.589874 
	C350.088715,187.604248 373.766541,169.810974 391.222198,144.874039 
	C392.434875,143.141647 393.651093,141.411774 395.390991,139.474579 
	C396.273712,141.128525 396.937988,142.987869 396.942474,144.848816 
	C397.009277,172.379776 396.967346,199.910965 397.034882,227.441925 
	C397.039520,229.327652 397.707977,231.211746 398.039886,233.525360 
	C397.968048,245.185516 389.809662,257.103546 379.835388,261.205017 
	C377.894531,262.003113 376.595245,264.361389 375.000000,266.000000 
	C293.645782,266.000000 212.291550,266.000000 130.468658,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M375.468658,266.000000 
	C376.595245,264.361389 377.894531,262.003113 379.835388,261.205017 
	C389.809662,257.103546 397.968048,245.185516 398.404541,233.278839 
	C398.809021,199.980759 398.820953,167.358002 398.832886,134.735229 
	C398.889435,100.101685 399.344482,65.460953 398.719788,30.839695 
	C398.565369,22.279394 392.964600,14.899257 386.323120,9.060859 
	C383.586609,6.655251 381.175751,3.657596 376.908325,3.831565 
	C376.414703,3.851688 375.861023,2.397612 375.667603,1.313509 
	C384.321777,1.000000 392.643585,1.000000 400.958344,1.000004 
	C400.951324,89.333344 400.951324,177.666687 400.951324,266.000000 
	C392.580872,266.000000 384.259094,266.000000 375.468658,266.000000 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M1.000000,249.470459 
	C2.198074,249.391068 3.765434,249.431366 4.528960,250.235199 
	C7.506862,253.370285 10.137333,256.834656 13.102452,259.983093 
	C14.039200,260.977722 15.670013,261.285187 16.889854,262.055023 
	C18.527510,263.088531 20.074575,264.265533 21.330267,265.690491 
	C14.413863,266.000000 7.827727,266.000000 1.000000,266.000000 
	C1.000000,260.649353 1.000000,255.295135 1.000000,249.470459 
z"/>
<path fill="#000000" opacity="1.000000" stroke="none" 
	d="
M20.530956,1.000000 
	C20.044394,2.137191 19.271978,3.993151 18.102503,4.291217 
	C11.971347,5.853875 9.413536,11.541220 5.042942,15.092823 
	C3.774555,16.123529 2.739237,17.441048 1.298538,18.313545 
	C1.000000,12.401347 1.000000,6.802694 1.000000,1.000000 
	C7.352935,1.000000 13.707425,1.000000 20.530956,1.000000 
z"/>
<path fill="#FE7005" opacity="1.000000" stroke="none" 
	d="
M227.286072,113.745033 
	C234.863174,120.125114 237.912003,128.104248 236.370026,137.369400 
	C234.677628,147.538284 228.726318,154.311691 218.852249,158.133865 
	C204.012802,163.878067 187.835068,155.793640 182.580811,145.455383 
	C175.404205,131.334686 181.815353,115.223495 195.871048,109.362076 
	C206.684402,104.852745 217.490707,105.654686 227.286072,113.745033 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M52.661282,158.737122 
	C44.901550,159.375320 37.459076,159.852341 30.011923,159.942352 
	C29.189156,159.952286 27.623730,157.757034 27.611017,156.571564 
	C27.446793,141.256897 27.447849,125.939339 27.602871,110.624496 
	C27.615435,109.383247 29.074377,107.077568 29.841093,107.086044 
	C40.156017,107.200150 50.719975,105.228981 60.392937,111.009003 
	C69.419792,116.402946 74.006760,125.872177 72.282448,136.667999 
	C70.546669,147.535645 62.682220,156.414139 52.661282,158.737122 
M55.447170,119.949936 
	C50.988144,118.560280 46.567757,117.022987 42.054184,115.841736 
	C39.712738,115.228951 38.307709,116.395439 38.319572,119.048653 
	C38.362614,128.677658 38.248199,138.308868 38.455811,147.933609 
	C38.479759,149.043747 40.247387,151.117477 41.040894,151.040314 
	C44.933743,150.661850 49.085175,150.402130 52.568352,148.825745 
	C63.158611,144.032883 65.542847,128.825668 55.447170,119.949936 
z"/>
<path fill="#0B0B0B" opacity="1.000000" stroke="none" 
	d="
M352.552307,154.606140 
	C348.758301,149.513397 345.194244,144.705078 341.630219,139.896759 
	C341.268158,139.956711 340.906097,140.016663 340.544037,140.076630 
	C340.544037,146.551025 340.544037,153.025421 340.544037,159.800659 
	C336.660797,159.800659 333.579987,159.800659 330.179413,159.800659 
	C330.179413,142.307846 330.179413,124.922653 330.179413,106.099030 
	C338.694092,106.993423 347.044830,107.368080 355.183868,108.881294 
	C361.942444,110.137840 364.533173,115.714241 364.909119,122.108505 
	C365.306946,128.875549 362.104919,133.746796 356.108215,136.807541 
	C355.671295,137.030548 355.130920,137.048019 354.687683,137.262405 
	C354.261078,137.468735 353.898071,137.806625 353.037750,138.423004 
	C358.305878,145.297867 363.506042,152.084091 368.718292,158.886032 
	C362.104492,161.955978 356.394440,160.501373 352.552307,154.606140 
M349.295990,116.987045 
	C347.361206,116.568123 345.397827,115.746521 343.502350,115.881088 
	C342.362610,115.962006 340.470520,117.466766 340.394806,118.445992 
	C340.055573,122.831413 340.247162,127.257912 340.247162,131.723755 
	C345.672272,132.224075 350.441223,131.796356 352.597443,127.270622 
	C354.172638,123.964508 354.085449,119.777092 349.295990,116.987045 
z"/>
<path fill="#101010" opacity="1.000000" stroke="none" 
	d="
M311.016449,136.966354 
	C308.401947,136.966354 306.275757,136.966354 303.901367,136.966354 
	C303.901367,141.818497 303.901367,146.203796 303.901367,151.094345 
	C310.261230,151.094345 316.342468,151.094345 322.743286,151.094345 
	C322.743286,154.317749 322.743286,157.045212 322.743286,159.896790 
	C312.870758,159.896790 303.110718,159.896790 292.991394,159.896790 
	C292.991394,142.292358 292.991394,124.933487 292.991394,107.213432 
	C302.852692,107.213432 312.600189,107.213432 322.714844,107.213432 
	C322.714844,109.800713 322.714844,112.500481 322.714844,115.704338 
	C316.598877,115.704338 310.513062,115.704338 304.018951,115.704338 
	C304.018951,119.892548 304.018951,123.600029 304.018951,128.118912 
	C308.668884,128.118912 313.254242,128.261932 317.825806,128.072571 
	C321.331909,127.927345 322.429016,129.337372 322.414825,132.773087 
	C322.401031,136.106247 321.192688,137.273071 317.990509,137.000931 
	C315.843140,136.818436 313.667664,136.966309 311.016449,136.966354 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M127.491417,153.456055 
	C120.628906,162.725540 100.828560,162.839111 93.533051,150.450394 
	C95.380234,148.607849 97.356888,146.636169 99.548904,144.449661 
	C103.877174,149.540756 108.699432,152.915863 115.153008,150.106186 
	C117.062218,149.274994 119.130226,146.897675 119.463158,144.945374 
	C119.742805,143.305527 118.050491,140.555008 116.444252,139.532715 
	C113.314720,137.540894 109.662315,136.344803 106.176018,134.944748 
	C98.862289,132.007645 95.459663,126.905350 96.530609,120.305748 
	C97.777779,112.620155 103.158325,107.600304 110.628853,107.015892 
	C117.469070,106.480797 123.693405,107.667938 128.992081,113.264893 
	C127.453514,115.302498 125.930054,117.320099 124.132080,119.701241 
	C122.985268,118.963821 122.000664,117.901329 120.851669,117.675598 
	C117.880363,117.091835 114.791534,116.418610 111.840584,116.708130 
	C110.358025,116.853584 108.147324,118.896690 107.963486,120.303482 
	C107.784508,121.673035 109.439941,123.880966 110.876518,124.740990 
	C114.072144,126.654076 117.569321,128.122894 121.059441,129.473389 
	C131.239426,133.412537 134.673691,143.623581 127.491417,153.456055 
z"/>
<path fill="#0D0D0D" opacity="1.000000" stroke="none" 
	d="
M273.594971,139.632874 
	C270.706238,145.726105 268.137299,151.541550 265.237030,157.186783 
	C264.578705,158.468216 262.799866,159.873306 261.485291,159.925583 
	C260.115143,159.980072 257.948853,158.805237 257.389832,157.589111 
	C251.113937,143.935867 245.080399,130.171219 238.983688,116.435646 
	C237.738647,113.630615 236.501801,110.821945 235.256653,108.004723 
	C242.890381,105.141685 245.990875,106.335297 248.891815,112.992851 
	C250.853439,117.494759 252.827530,121.991280 254.809052,126.484474 
	C256.771637,130.934601 258.750549,135.377518 261.210541,140.924469 
	C263.981689,134.896301 266.467804,129.659103 268.803223,124.355522 
	C270.780640,119.864838 272.531525,115.274803 274.479126,110.770447 
	C276.289185,106.584183 279.050110,105.905022 287.635345,107.525002 
	C282.997864,118.169395 278.396271,128.731400 273.594971,139.632874 
z"/>
<path fill="#0F0F10" opacity="1.000000" stroke="none" 
	d="
M150.236664,109.144753 
	C159.026398,104.641586 167.361191,105.174217 175.794708,109.771538 
	C175.794708,112.957642 175.794708,116.423447 175.794708,119.297028 
	C170.616806,118.213997 165.483582,116.342392 160.327332,116.276611 
	C154.686447,116.204628 150.159302,119.457275 147.168182,124.556931 
	C143.160355,131.389984 144.112747,140.182816 149.678726,145.943756 
	C155.970352,152.455734 164.880905,152.801727 175.516144,146.671677 
	C175.516144,150.393784 175.516144,153.892029 175.516144,157.534409 
	C165.933212,161.337082 156.372299,161.420532 147.186890,156.019775 
	C130.909943,146.449402 129.325531,125.708069 143.895615,113.630745 
	C145.792358,112.058525 147.875793,110.711555 150.236664,109.144753 
z"/>
<path fill="#161617" opacity="1.000000" stroke="none" 
	d="
M82.125801,106.829216 
	C84.176064,106.922424 85.814064,107.015572 87.664238,107.120781 
	C87.664238,124.743286 87.664238,142.028473 87.664238,159.247177 
	C87.289246,159.502716 87.042946,159.805023 86.760689,159.843475 
	C76.901749,161.186569 76.901276,161.183044 76.901283,151.542374 
	C76.901299,138.209427 77.016640,124.874832 76.827606,111.544556 
	C76.774239,107.782036 78.015854,106.263535 82.125801,106.829216 
z"/>
<path fill="#F9852C" opacity="1.000000" stroke="none" 
	d="
M398.487000,134.787598 
	C398.820953,167.358002 398.809021,199.980759 398.432434,232.850067 
	C397.707977,231.211746 397.039520,229.327652 397.034882,227.441925 
	C396.967346,199.910965 397.009277,172.379776 396.942474,144.848816 
	C396.937988,142.987869 396.273712,141.128525 395.541656,139.156189 
	C396.158356,137.642624 397.149750,136.241287 398.487000,134.787598 
z"/>
<path fill="#D6DBDE" opacity="1.000000" stroke="none" 
	d="
M55.771961,120.135384 
	C65.542847,128.825668 63.158611,144.032883 52.568352,148.825745 
	C49.085175,150.402130 44.933743,150.661850 41.040894,151.040314 
	C40.247387,151.117477 38.479759,149.043747 38.455811,147.933609 
	C38.248199,138.308868 38.362614,128.677658 38.319572,119.048653 
	C38.307709,116.395439 39.712738,115.228951 42.054184,115.841736 
	C46.567757,117.022987 50.988144,118.560280 55.771961,120.135384 
z"/>
<path fill="#CFD4D7" opacity="1.000000" stroke="none" 
	d="
M349.701965,117.096481 
	C354.085449,119.777092 354.172638,123.964508 352.597443,127.270622 
	C350.441223,131.796356 345.672272,132.224075 340.247162,131.723755 
	C340.247162,127.257912 340.055573,122.831413 340.394806,118.445992 
	C340.470520,117.466766 342.362610,115.962006 343.502350,115.881088 
	C345.397827,115.746521 347.361206,116.568123 349.701965,117.096481 
z"/>
</svg>